/**
 * Created by Dhanya Akhil on 2/17/2017.
 */
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import {FaqComponent} from "./components/faq.component";
import {CanActivateViaAuthGuard} from '../../shared/services/auth.service';

const routes= [{path:'faq',
                component:FaqComponent,
                canActivate:[CanActivateViaAuthGuard]
                }];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
  providers: []
})
export class FaqRoutingModule { }
